var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-path"},_vm._l((_vm.parents),function(parent,index){return _c('span',{key:parent.id},[(index > 0)?_c('span',[_vm._v(" / ")]):_vm._e(),_c('span',{staticClass:"parent-label"},[_vm._v(_vm._s(parent.name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }